module.exports = __webpack_public_path__ + "img/mcgl_fp_07.3f38459d.png";